import { from, map, Observable, of, Subject } from 'rxjs';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { NavHelper } from '../../helpers';

@Injectable({
  providedIn: 'root',
})
export class NativePushNotificationService {
  public readonly tokenReceived: Subject<string> = new Subject();

  constructor(
    private _navHelper: NavHelper,
    private _analyticsService: AnalyticsService,
  ) {
    this.isPermissionGranted().subscribe((granted) => {
      if (granted) {
        this.addListeners();
      }
    });
  }

  public requestPermission(): Observable<boolean> {
    if (Capacitor.getPlatform() === 'web') {
      return of(false);
    }
    return from(PushNotifications.requestPermissions()).pipe(
      map((result) => {
        if (result.receive === 'granted') {
          PushNotifications.register();
          this.addListeners();
          this._analyticsService.subscribedToPushNotifications({
            platform: Capacitor.getPlatform(),
          });
          return true;
        } else {
          return false;
        }
      }),
    );
  }

  public isPermissionGranted(): Observable<boolean> {
    if (Capacitor.getPlatform() === 'web') {
      return of(false);
    }

    return from(PushNotifications.checkPermissions()).pipe(
      map((result) => result.receive === 'granted'),
    );
  }

  public canRequestPermission(): Observable<boolean> {
    if (Capacitor.getPlatform() === 'web') {
      return of(false);
    }

    return from(PushNotifications.checkPermissions()).pipe(
      map(
        (result) =>
          result.receive === 'prompt' ||
          result.receive === 'prompt-with-rationale',
      ),
    );
  }

  public checkInitialNotification(): Observable<void> {
    if (Capacitor.getPlatform() === 'web') {
      return;
    }

    return from(PushNotifications.getDeliveredNotifications()).pipe(
      map((data) => {
        if (data?.notifications?.length) {
          const last = data.notifications[data.notifications.length - 1];

          console.log('Initial notification: ', JSON.stringify(last));

          //this._analyticsService.nativePushActionPerformed(last);

          this._analyticsService.pushNotificationClicked(last?.data);

          if (last?.data?.chatId) {
            this._navHelper.goToChat(last.data.chatId);
          }
        }
      }),
    );
  }

  private addListeners(): void {
    PushNotifications.addListener('registration', (token: Token) => {
      this.tokenReceived.next(token.value);

      console.log('My token: ' + JSON.stringify(token));
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      console.log('Push notification Error', +JSON.stringify(error));
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        console.log('Push received: ', JSON.stringify(notification));

        // this._analyticsService.nativePushReceived(notification);

        if (notification?.data?.chatId) {
          this._navHelper.goToChat(notification.data.chatId);
        }
      },
    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (notification: ActionPerformed) => {
        const data = notification.notification.data;
        // this._analyticsService.nativePushActionPerformed(
        //   notification.notification,
        // );
        this._analyticsService.pushNotificationClicked(
          notification?.notification?.data,
        );

        console.log(
          'Action performed: ',
          JSON.stringify(notification.notification),
        );

        if (data?.chatId) {
          this._navHelper.goToChat(data?.chatId);
        }
      },
    );
  }
}
